// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U4NU","title":"styles_title__1puS1"};